// Import React and Chart.js components
import React, { useEffect, useRef, useState } from 'react';
import { BeatLoader } from 'react-spinners';
import { Bar, Line } from 'react-chartjs-2';
import Chart from 'chart.js/auto';
import { proxy } from './../process/api';

const DashChart = () => {

  const [chartHeight, setChartHeight] = useState('200px');
  const [chartLabels, setChartLabels] = useState(["OCT", "NOV", "DEC", "JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP"]);
  const [chartData, setChartData] = useState([]);
  const [isChartLoading, setChartLoading] = useState(true);
  const [trendACHGTHData, setTrendData] = useState([]);
  const [trendLoading, setTrendLoading] = useState(true);
  const aristoMonths = ["OCT", "NOV", "DEC", "JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP"];
  var chartCanvasHeight  = 130;

  const getChartData = async () => {


   
    const selected_year = localStorage.getItem('selected_year');
    const selected_month = localStorage.getItem('selected_month');
    const selected_div = localStorage.getItem('selected_div');
    const selected_depo = localStorage.getItem('selected_depo');

    const apiResponse = await proxy(`/api/mis/dashboardchart/${selected_year}/${selected_div}/${selected_depo}`, {}, "get", true);
    if (apiResponse.chart_type) {
      setChartLoading(false);

      setChartLabels(apiResponse.chart_labels)
      const temp_dataset = apiResponse.data_set;

      var chartArrayProcessed = [];
      temp_dataset.map((singleData, index) => {
        chartArrayProcessed.push({
          label: String(singleData.dataset_label).toUpperCase(),
          data: singleData.values,
          borderColor: singleData.data_set_color,
          backgroundColor: singleData.data_set_color,
          borderWidth: 2, //zero when bar chart
          borderRadius: 0, //zero when bar chart
          tension: 0.1, //remove when bar chart
          borderSkipped: true, //false when bar chart
        });
      });

      setChartData(chartArrayProcessed);
      setChartLoading(false);
    }

    const apiACHGTHResponse = await proxy(`/api/mis/dashboardachgthtrend/${selected_year}/${selected_div}/${selected_depo}`, {}, "get", true);
    if (apiACHGTHResponse.data) {
      setTrendData(apiACHGTHResponse.data[0]);
      setTrendLoading(false)
    }

  }

  useEffect(() => {
    return;
    setTimeout(() => {
      if (document.querySelector('#chartContainer canvas')) {
        var canvas = document.querySelector('#chartContainer canvas');

        var style = window.getComputedStyle(canvas);
        var renderedWidth = style.width;
        var elements = document.querySelectorAll('.templist');
        elements.forEach(function (element) {
          element.style.width = renderedWidth;

        });
      }
    }, 1000);

  }, [isChartLoading, trendLoading]);

  useEffect(() => {
    const mainContentElement = document.querySelector('.main-content');
  
    if (mainContentElement) {
      const mainContentHeight = mainContentElement.offsetHeight - 10;
      if(mainContentHeight > 290){
        chartCanvasHeight = 280;
      }
      const newChartHeight = Math.max(mainContentHeight - 380, 0);
      setChartHeight(`${newChartHeight}px`);
    }
    getChartData();

  }, []);


  const trendDataColor = (val) =>{
    if(val == 0){
      return "alert alert-light";
    }
    if(val > 0){
      return "alert alert-success";
    }
    if(val < 0){
      return "alert alert-danger";
    }

  }
  // const spacedMonths = chartLabels.map(month => `${month} `);

  const data = {
    maintainAspectRatio: false, // Add this line
    responsive: true,
    labels: chartLabels,
    datasets: chartData,

  };
  const options = {
    plugins: { tooltip: { backgroundColor: "rgba(188, 211, 232, 0.9)", titleColor: "rgba(0,0,0,1)", bodyColor: "rgb(30,30,30)" }, legend: { position: "right" } },
    layout: {
      padding: 0
    },
    scales: {
      y: {
        beginAtZero: true,
      },
    },
  };

  return (

    <>
      {isChartLoading ?
        <div >
          <BeatLoader color="#1940a9" />
        </div>
        :
        <>
          <div style={{ height: chartHeight, padding: `10px 5px` }} id='chartContainer'>
            
           

            <div className='trendContainer'>
            <ul className='templist labels'>
            <li>&nbsp;</li>
              <li>OCT</li>
              <li>NOV</li>
              <li>DEC</li>
              <li>JAN</li>
              <li>FEB</li>
              <li>MAR</li>
              <li>APR</li>
              <li>MAY</li>
              <li>JUN</li>
              <li>JUL</li>
              <li>AUG</li>
              <li>SEP</li>

            </ul>

            {!trendLoading && <>
              <ul className='templist'>
              <li>  <strong style={{ fontWeight: 800 }}>ACH%</strong> </li>
                {aristoMonths.map((month, index) => (
                  <li key={index}  className={trendDataColor(trendACHGTHData.ach_per[month])}>
                   
                     
                     {trendACHGTHData.ach_per[month]}
                    
                  </li>
                ))}
              </ul>
              <ul className='templist'>
                <li>  <strong style={{ fontWeight: 800 }}>GTH%</strong> </li>
              {aristoMonths.map((month, index) => (
                  <li key={index} className={trendDataColor(trendACHGTHData.gth_per[month])}>
                  
                 
                       {trendACHGTHData.gth_per[month]}
                
                  </li>
                ))}
              </ul> </>}
              </div>
              <Line data={data} options={options} width={800} height={chartCanvasHeight} />
          </div>
        </>
      }

    </>

  );
};

export default DashChart;
